// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { useSignUpEmailPassword } from '@nhost/react';

import { useState } from 'react';
import { FiUser, FiMail, FiLock } from 'react-icons/fi';
import { Link, Navigate, useNavigate } from 'react-router-dom';

// export const CREATE_USER_INFO = gql`
//   mutation Insert_User_Info_One($firstName: String!, $lastName: String!, $email: String!) {
//     insert_user_info_one(object: { firstName: $firstName, lastName: $lastName, email: $email }) {
//       id
//     }
//   }
// `;

function SignUp() {
  const textColor = useColorModeValue('gray.700', 'white');
  const bgColor = useColorModeValue('white', 'gray.800');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const inputBg = useColorModeValue('gray.50', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const iconColor = useColorModeValue('gray.500', 'gray.400');

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('seller');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const navigate = useNavigate();

  // https://docs.nhost.io/reference/react/use-sign-up-email-password
  const { signUpEmailPassword, needsEmailVerification, isLoading, isSuccess } = useSignUpEmailPassword();

  // console.log('Error', error);

  // const {
  //   signUpEmailPassword,
  //   isLoading: isLoadingRegister,
  //   isError,
  //   error: signUpError,
  // } = useSignUpEmailPassword();

  // const [createUserInfo, { loading: isCreatingUserInfo, error: UserInfoError }] = useMutation(CREATE_USER_INFO);
  // console.log('ERRROR', error, isError, isCreatingUserInfo, UserInfoError);

  // const handleRoute = () => {
  //   return <Navigate to="/" replace={true} />;
  // };

  // useEffect(() => {
  //   console.log('Success', isSuccess);
  //   if (isSuccess) {
  //     <Navigate to="/" replace={true} />;
  //   }
  // }, [isSuccess]);

  const handleOnSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();

    const allowedRoles = role === 'seller' ? ['seller', 'me'] : ['user', 'me'];
    await signUpEmailPassword(email, password, {
      displayName: `${firstName} ${lastName}`,
      defaultRole: allowedRoles[0],
      allowedRoles,
      metadata: {
        firstName,
        lastName,
      },
      // redirectTo: 'http://localhost:3000',
    });

    if (isSuccess) {
      navigate('/');
    }

    // const { error } = await signUpEmailPassword(email, password, {
    //   displayName: `${firstName} ${lastName}`.trim(),
    //   defaultRole: role === 'seller' ? 'seller' : 'user',
    //   allowedRoles: [role],
    //   metadata: {
    //     firstName,
    //     lastName,
    //     role,
    //   },
    //   redirectTo: 'chamcha://login',
    // });

    // console.log('EEEE', error);

    // .then(async () => {
    //   await createUserInfo({
    //     variables: {
    //       firstName: firstName,
    //       lastName: lastName,
    //       email: email,
    //     },
    //   });
    // });

    // Info: On the time of development , the role is ignored and default is used. So this is trick to set the user role

    // signUpEmailPassword(email, password, {
    //   displayName: `${firstName} ${lastName}`.trim(),

    //   // defaultRole: role,
    //   // allowedRoles: [role],
    //   metadata: {
    //     firstName,
    //     lastName,
    //     // role: role,
    //   },
    // }).then(async () => {
    //   await createUserInfo({
    //     variables: {
    //       firstName: firstName,
    //       lastName: lastName,
    //       email: email,
    //     },
    //   });
    // });
  };

  if (isSuccess) {
    return <Navigate to="/" replace={true} />;
  }

  const disableForm = isLoading || needsEmailVerification;

  return (
    <Box minH="100vh" bg={bgColor}>
      {/* Hero Section with Gradient Overlay */}
      <Box
        bgImage="linear-gradient(to right, rgba(255, 26, 61, 0.85), rgba(255, 94, 0, 0.85)), url('/assets/img/food.jpg')"
        bgSize="cover"
        bgPosition="center"
        height="40vh"
        position="relative"
        boxShadow="xl"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <VStack spacing={4}>
          <Heading color="white" fontSize={{ base: "3xl", md: "4xl" }} fontWeight="bold">
            Create Account
          </Heading>
          <Text color="white" fontSize={{ base: "md", md: "lg" }} textAlign="center" maxW="md">
            Join our platform and start managing your restaurant today
          </Text>
        </VStack>
      </Box>

      {/* Sign Up Form */}
      <Container maxW="lg" py={12} zIndex={10} position="relative" top="-10">
        <VStack
          spacing={8}
          bg={bgColor}
          borderRadius="xl"
          p={{ base: 6, md: 8 }}
          mt="-20"
          borderTop="4px solid"
          borderTopColor="brand.500"
          boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)">
          <VStack spacing={2} w="full">
            <Heading size="lg" color={textColor} textAlign="center">
              Sign Up
            </Heading>
            <Text color="gray.500" textAlign="center">
              Create your account to get started
            </Text>
          </VStack>

          {/* <VStack w="full" spacing={4}>
            <HStack w="full">
              <Divider borderColor={borderColor} />
              <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" px={2}>
                or sign up with
              </Text>
              <Divider borderColor={borderColor} />
            </HStack>

            <HStack spacing={4} w="full">
              <Button
                variant="outline"
                leftIcon={FaGoogle as any}
                borderColor={borderColor}
                _hover={{ bg: hoverBg }}
                flex={1}
                isDisabled={disableForm}
              >
                Google
              </Button>
              <Button
                variant="outline"
                leftIcon={FaFacebook as any}
                borderColor={borderColor}
                _hover={{ bg: hoverBg }}
                flex={1}
                isDisabled={disableForm}
              >
                Facebook
              </Button>
              <Button
                variant="outline"
                leftIcon={FaApple as any}
                borderColor={borderColor}
                _hover={{ bg: hoverBg }}
                flex={1}
                isDisabled={disableForm}
              >
                Apple
              </Button>
            </HStack>
           </VStack> */}

          <HStack spacing={4} w="full">
            <FormControl id="firstName" isRequired>
              <FormLabel>First Name</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <Icon as={FiUser as any} color={iconColor} />
                </InputLeftElement>
                <Input
                  type="text"
                  placeholder="John"
                  bg={inputBg}
                  borderColor={borderColor}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  disabled={disableForm}
                  _focus={{ borderColor: brandColor }}
                />
              </InputGroup>
            </FormControl>

            <FormControl id="lastName" isRequired>
              <FormLabel>Last Name</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <Icon as={FiUser as any} color={iconColor} />
                </InputLeftElement>
                <Input
                  type="text"
                  placeholder="Doe"
                  bg={inputBg}
                  borderColor={borderColor}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  disabled={disableForm}
                  _focus={{ borderColor: brandColor }}
                />
              </InputGroup>
            </FormControl>
          </HStack>

          <FormControl id="email" isRequired>
            <FormLabel>Email</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <Icon as={FiMail as any} color={iconColor} />
              </InputLeftElement>
              <Input
                type="email"
                placeholder="your.email@example.com"
                bg={inputBg}
                borderColor={borderColor}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={disableForm}
                _focus={{ borderColor: brandColor }}
              />
            </InputGroup>
          </FormControl>

          <FormControl id="password" isRequired>
            <FormLabel>Password</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <Icon as={FiLock as any} color={iconColor} />
              </InputLeftElement>
              <Input
                type="password"
                placeholder="Create a strong password"
                bg={inputBg}
                borderColor={borderColor}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={disableForm}
                _focus={{ borderColor: brandColor }}
              />
            </InputGroup>
          </FormControl>

          <FormControl id="role" isRequired>
            <FormLabel>Account Type</FormLabel>
            <RadioGroup onChange={setRole} value={role} colorScheme="brand">
              <Stack direction={{ base: "column", sm: "row" }} spacing={5}>
                {/* <Radio value="user">Customer</Radio> */}
                <Radio value="seller">Restaurant Owner</Radio>
              </Stack>
            </RadioGroup>
          </FormControl>

          <FormControl id="terms" isRequired>
            <Checkbox
              isChecked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)}
              colorScheme="brand"
              size="md"
            >
              <Text fontSize="sm" color={textColor}>
                I agree to the{' '}
                <Link to="/terms-and-conditions" color={brandColor}>
                  Terms & Conditions
                </Link>
                {' '}and{' '}
                <Link to="/privacy-policy" color={brandColor}>
                  Privacy Policy
                </Link>
              </Text>
            </Checkbox>
          </FormControl>

          <Button
            w="full"
            colorScheme="brand"
            size="lg"
            fontSize="md"
            mt={4}
            onClick={handleOnSubmit}
            isLoading={isLoading}
            isDisabled={disableForm || !acceptTerms}
            leftIcon={FiUser as any}
          >
            Create Account
          </Button>

          <Text color={textColor} fontSize="sm" textAlign="center">
            Already have an account?{" "}
            <Link to="/sign-in">
              <Text as="span" color={brandColor} fontWeight="semibold">
                Sign In
              </Text>
            </Link>
          </Text>

          <VStack spacing={2} w="full">
            <HStack spacing={4} justify="center">
              <Link to="/terms-and-conditions">
                <Text color="gray.500" fontSize="xs" _hover={{ color: brandColor }}>
                  Terms & Conditions
                </Text>
              </Link>
              <Text color="gray.400" fontSize="xs">•</Text>
              <Link to="/privacy-policy">
                <Text color="gray.500" fontSize="xs" _hover={{ color: brandColor }}>
                  Privacy Policy
                </Text>
              </Link>
            </HStack>
          </VStack>

          {needsEmailVerification && (
            <Box mt={4} p={4} bg="blue.50" color="blue.800" borderRadius="md">
              <Text textAlign="center">
                Please check your email inbox and click the verification link to complete your registration.
              </Text>
            </Box>
          )}
        </VStack>
      </Container>
    </Box>
  );
}

export default SignUp;
